import React, { useCallback } from 'react';
import { SxProp } from 'dripsy';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { useNavigation } from '@react-navigation/native';

import {
  screens,
  SearchNavigatorNavigationPropType,
} from '@navigation';
import { ListLayout, TrackList } from '@components';
import { useTracksModel } from '@models/Tracks/TracksModel';
import type { Track } from '@models/Tracks/TrackModel';

const contentContainerStyle: SxProp = {
  px: ['$6', '$0'],
};

type NavigationPropType =
  SearchNavigatorNavigationPropType<'SearchTrack'>;

// TODO: Use searched track list model when it's ready
export const SearchTrackScreen = observer(() => {
  const { t } = useTranslation();
  const nav = useNavigation<NavigationPropType>();
  const tracks = useTracksModel();

  const navigateToTrack = useCallback((item: Track) => {
    nav.navigate(screens.MusicNavigator, {
      screen: screens.Track,
      params: { id: item.id },
    });
  }, []);

  const isLoading =
    tracks.latest.fetchPreview.inProgress &&
    !tracks.latest.fetchPreview.hasEverBeenRun;

  return (
    <ListLayout title={t('search.title')}>
      <TrackList
        contentContainerSx={contentContainerStyle}
        data={tracks.latest.preview}
        isLoading={isLoading}
        onPress={navigateToTrack}
      />
    </ListLayout>
  );
});
